export default {
  validation: "This field is mandatory",
  invalidDate: "Please enter a valid date.",
};
